import {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {ID, IStoryAnswerLog, callbackProps} from '../../constants'
import {actionGetStoryQuestions} from '../../redux/education'
import {actionGetStoryAnswerLogs} from '../../redux/question/actions/story-answer-log.action'
import {QuizQuestion} from './quizReport'

export type HomeworkQuiz = {questions: QuizQuestion[]; logs: IStoryAnswerLog[]; loading: boolean; error: boolean; reload: () => void}

export function useHomeworkQuiz(storyId: number, languageCode: string, classroomId: ID, enabled: boolean): HomeworkQuiz {
  const dispatch = useDispatch()
  const [retry, setRetry] = useState(0)
  const [state, setState] = useState<Omit<HomeworkQuiz, 'reload'>>({questions: [], logs: [], loading: false, error: false})
  const scope = `${storyId}-${languageCode}-${classroomId}-${enabled}`
  const [loadedScope, setLoadedScope] = useState('')
  useEffect(() => {
    let active = true
    setState({questions: [], logs: [], loading: Boolean(enabled && storyId && classroomId), error: false})
    setLoadedScope(scope)
    if (!enabled || !storyId || !classroomId) return
    let pending = 2
    let failed = false
    let questions: QuizQuestion[] = []
    let logs: IStoryAnswerLog[] = []
    const finish = (result: callbackProps, kind: 'questions' | 'logs') => {
      if (!active) return
      const data = result.payload?.data
      const empty = data?.errorName === 'NotFound' || result.payload?.errorName === 'NotFound'
      if (result.type === 'SUCCESS' && Array.isArray(data)) {
        if (kind === 'questions') questions = data
        else logs = data.filter((log: IStoryAnswerLog) => !log.isDeleted && String(log.storyId) === String(storyId) && String(log.classroomId) === String(classroomId))
      } else if (!empty) failed = true
      pending--
      if (!pending) setState({questions: failed ? [] : questions, logs: failed ? [] : logs, loading: false, error: failed})
    }
    dispatch(actionGetStoryQuestions({StoryId: storyId, LanguageCode: languageCode, ShowType: 'HomeworkDetail'}, result => finish(result, 'questions')))
    dispatch(actionGetStoryAnswerLogs({storyId, classroomId}, result => finish(result, 'logs')))
    return () => {active = false}
  }, [dispatch, storyId, languageCode, classroomId, enabled, retry, scope])
  return {...(loadedScope === scope ? state : {questions: [], logs: [], loading: enabled, error: false}), reload: () => setRetry(value => value + 1)}
}
